module.exports = __webpack_public_path__ + "img/jnd.ef5c23aa.webp";